import React from 'react';
import { ArrowLeftIcon, Clock3Icon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
interface Order {
  id: string;
  name: string;
  status: 'pending' | 'in-progress' | 'completed';
  deadline: Date;
}
interface ModuleOrdersOverviewProps {
  moduleName: string;
  orders: Order[];
  onOrderSelect: (orderId: string) => void;
  onBackToOverview: () => void;
}
export function ModuleOrdersOverview({
  moduleName,
  orders,
  onOrderSelect,
  onBackToOverview
}: ModuleOrdersOverviewProps) {
  const getStatusBadge = (status: Order['status']) => {
    switch (status) {
      case 'pending':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-854">
            <Clock3Icon size={12} className="mr-1" data-id="element-855" />
            Ausstehend
          </span>;
      case 'in-progress':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-856">
            <Clock3Icon size={12} className="mr-1" data-id="element-857" />
            In Bearbeitung
          </span>;
      case 'completed':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-858">
            <CheckCircleIcon size={12} className="mr-1" data-id="element-859" />
            Abgeschlossen
          </span>;
      default:
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-860">
            <AlertCircleIcon size={12} className="mr-1" data-id="element-861" />
            Unbekannt
          </span>;
    }
  };
  return <div className="container mx-auto" data-id="element-862">
      <div className="mb-8" data-id="element-863">
        <div data-id="element-864">
          <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-865">
            Aufträge für {moduleName}
          </h2>
          <p className="text-gray-600 mb-4" data-id="element-866">
            Wählen Sie einen Auftrag aus, um mit der Arbeit zu beginnen
          </p>
          <button onClick={onBackToOverview} className="flex items-center gap-2 px-4 py-2 rounded-md text-gray-700" data-id="element-867">
            <ArrowLeftIcon size={16} data-id="element-868" />
            <span data-id="element-869">Zurück zur Übersicht</span>
          </button>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6" data-id="element-870">
        <h3 className="text-xl font-bold text-gray-800 mb-6" data-id="element-871">
          Auftragsübersicht
        </h3>
        <div className="space-y-4" data-id="element-872">
          {orders.map(order => <div key={order.id} onClick={() => onOrderSelect(order.id)} className="border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer" data-id="element-873">
              <div className="flex justify-between items-center" data-id="element-874">
                <div data-id="element-875">
                  <h4 className="font-medium text-gray-900" data-id="element-876">{order.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-877">
                    Fällig:{' '}
                    {order.deadline.toLocaleTimeString('de-DE', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}{' '}
                    Uhr
                  </p>
                </div>
                <div data-id="element-878">{getStatusBadge(order.status)}</div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}